export default __webpack_public_path__ + "static/media/cybersec-2026-banner.f6195b65.png";